import { Provider } from "react-redux";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import Auth from "./layout/Auth";
import Main from "./layout/Main";
import PublicView from "./layout/PublicView";
import routes from "./routes";
import store from "./store";
import "./assets/scss/custom.scss";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://fcbbc299e2bbe06daffaa2644cc349ff@o4507571489210368.ingest.de.sentry.io/4509054350196816",
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
  });
}
console.log("env", process.env.REACT_APP_NODE_ENV);
function App() {
  return (
    <>
      <Provider store={store}>
        <BrowserRouter>
          <Switch>
            {routes.map((route) => {
              switch (route.layout) {
                case "main":
                  return (
                    <Route exact path={route.path}>
                      <Main>
                        <route.component />
                      </Main>
                    </Route>
                  );
                case "auth":
                  return (
                    <Route exact path={route.path}>
                      <Auth>
                        <route.component />
                      </Auth>
                    </Route>
                  );
                case "public":
                  return (
                    <Route exact path={route.path}>
                      <PublicView>
                        <route.component />
                      </PublicView>
                    </Route>
                  );
              }
            })}
            <Redirect to="/" />
          </Switch>
        </BrowserRouter>
      </Provider>
    </>
  );
}

export default process.env.NODE_ENV === "production"
  ? Sentry.withErrorBoundary(App, {
      fallback: (
        <div className="d-flex flex-column align-items-center justify-content-center text-danger py-5">
          <div className="fw-bold text-center fs-1">
            Something went wrong. Please try again later. 🚨
          </div>
        </div>
      ),
    })
  : App;
